import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Optional dynamic theme enhancements. Remove this line to fall back to the current static design.
// import './styles/dynamic-theme.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
